<template>
  <StepLayout
    :keyword="keyword"
    title="医療機関を受診していますか？"
    :current-step="3"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="medicalVisitOptions"
      aria-label="受診状況の選択"
      @select="handleSelect"
    />

    <template #skip>
      <SkipLink label="質問をスキップ" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayoutInline.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { MedicalVisitOption } from '../../types';
import { medicalVisitOptions } from '../../questions';

defineProps<{
  keyword: string;
}>();

const model = defineModel<MedicalVisitOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
